var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 36,
    viewBox: "0 0 34 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 34.25V25.4866C13.25 24.875 13.875 24.25 14.5 24.25H19.5C20.125 24.25 20.75 24.875 20.75 25.5V34.25C20.75 34.9404 21.3096 35.5 22 35.5H32C32.6904 35.5 33.25 34.9404 33.25 34.25V16.75C33.25 16.4185 33.1183 16.1005 32.8839 15.8661L29.5 12.4822V4.25C29.5 3.55964 28.9404 3 28.25 3H25.75C25.0596 3 24.5 3.55964 24.5 4.25V7.48223L17.8839 0.866117C17.3957 0.377961 16.6043 0.377961 16.1161 0.866117L1.11612 15.8661C0.881696 16.1005 0.75 16.4185 0.75 16.75V34.25C0.75 34.9404 1.30964 35.5 2 35.5H12C12.6904 35.5 13.25 34.9404 13.25 34.25Z",
    fill: "#0E82FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceIcon2);
export default __webpack_public_path__ + "static/media/price-icon2.200c6fdf43865c7be237fa1f387e685c.svg";
export { ForwardRef as ReactComponent };